import React from 'react';
import InfoField from './InfoField';

const VerifierDetailsSection = ({ verifierData }) => {
  if (!verifierData) return null; // Prevent rendering if data is missing

  return (
    <div className="report-section">
      <h2 className="section-title">Verifier Details</h2>
      <div className="grid-container">
        <InfoField
          label="Verifier EmployeeCode"
          value={verifierData.verifierEmployeeCode || 'N/A'}
        />
        <InfoField
          label="Verifier Email"
          value={verifierData.verifierEmail || 'N/A'}
        />
        <InfoField
          label="Verifier Mobile Number"
          value={verifierData.verifierMobileNumber || 'N/A'}
        />
        <InfoField
          label="Report Date"
          value={verifierData.reportDate || 'N/A'}
        />
      </div>
    </div>
  );
};

export default VerifierDetailsSection;
